import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState, useRef, useEffect } from "react";
import classnames from "classnames";
import { useIntersectionObserver } from "@/hooks";
import styles from "@/styles/InfinityScrollList.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function InfinityScrollList(_ref) {
  var _observerOpts;

  var loadMore = _ref.loadMore,
      fetchMore = _ref.fetchMore,
      observerOpts = _ref.observerOpts,
      children = _ref.children;

  var _useState = useState(false),
      loadingMore = _useState[0],
      setLoadingMore = _useState[1];

  var loader = useRef(); // TODO: optionは調整する

  observerOpts = (_observerOpts = observerOpts) !== null && _observerOpts !== void 0 ? _observerOpts : {
    root: null,
    rootMargin: "10px",
    threshold: 0.25
  };
  var intersect = useIntersectionObserver(loader, observerOpts);
  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(loadMore && intersect && !loadingMore)) {
              _context.next = 5;
              break;
            }

            setLoadingMore(true);
            _context.next = 4;
            return fetchMore();

          case 4:
            setLoadingMore(false);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [loadMore, intersect, loadingMore]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: children
    }), /*#__PURE__*/_jsx("div", {
      ref: loader,
      className: classnames(styles.loader, _defineProperty({}, styles.show, loadMore)),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.spinner,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.bounce1
        }), /*#__PURE__*/_jsx("div", {
          className: styles.bounce2
        }), /*#__PURE__*/_jsx("div", {
          className: styles.bounce3
        })]
      })
    })]
  });
}